import PropTypes from 'prop-types';
import { Box, ListItem as MuiListItem, ListItemButton } from '@mui/material';

import { ACTION_MENU_BUTTON_TYPE, componentsSize, LABEL_TYPES, STATUS_TYPES } from 'constants/components';
import { useBreakpointFlags } from 'hooks/useBreakpointFlags';
import { ActionsMenu, IconsActions } from 'components/simple';

import { ListItemContent } from './ListItemContent';

const styles = {
  container: ({ palette, breakpoints }) => ({
    height: '100%',
    padding: 'unset !important',
    marginBottom: 2,
    borderRadius: 5,
    alignItems: 'flex-start',
    border: `2px solid ${palette.colors.darkPale}`,
    [breakpoints.up('md')]: {
      alignItems: 'center',
      height: 180,
    },
    '.MuiListItemSecondaryAction-root': {
      top: 32,
      right: 8,
      [breakpoints.up('md')]: {
        top: '50%',
        right: 40,
      },
    },
  }),
  listItemButton: ({ spacing, breakpoints }) => ({
    width: '100%',
    height: '100%',
    paddingInline: 1,
    paddingBlock: 2,
    display: 'flex',
    [breakpoints.up('md')]: {
      paddingLeft: 5,
      paddingRight: `${spacing(14)} !important`,
      paddingBlock: 1,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-disabled': {
      opacity: 1,
    },
  }),
};

const ListItem = ({
  itemId,
  itemName,
  statusType,
  labelType = null,
  itemCaption = null,
  itemActions = null,
  isItemClickable = false,
  onItemClick = null,
  withTopStatus = false,
  nameLength = 0,
}) => {
  const { isMdUp: isMdWidth } = useBreakpointFlags();
  const showTopStatus = withTopStatus && isMdWidth;
  const isDisabledClick = !isItemClickable || typeof onItemClick !== 'function';

  return (
    <MuiListItem
      sx={styles.container}
      secondaryAction={
        showTopStatus ? (
          <IconsActions actions={itemActions} />
        ) : (
          <ActionsMenu
            options={itemActions}
            id={`item-actions-${itemId}`}
            buttonProps={{
              type: ACTION_MENU_BUTTON_TYPE.ICON,
              size: componentsSize.large,
              colored: false,
            }}
          />
        )
      }
    >
      {isDisabledClick ? (
        <Box sx={styles.listItemButton}>
          <ListItemContent
            isDisabledClick
            showTopStatus={showTopStatus}
            itemName={itemName}
            labelType={labelType}
            statusType={statusType}
            itemCaption={itemCaption}
            nameLength={nameLength}
          />
        </Box>
      ) : (
        <ListItemButton disableRipple onClick={onItemClick} sx={styles.listItemButton}>
          <ListItemContent
            showTopStatus={showTopStatus}
            itemName={itemName}
            labelType={labelType}
            statusType={statusType}
            itemCaption={itemCaption}
            nameLength={nameLength}
          />
        </ListItemButton>
      )}
    </MuiListItem>
  );
};

ListItem.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  statusType: PropTypes.oneOf(Object.values(STATUS_TYPES)).isRequired,
  labelType: PropTypes.oneOf(Object.values(LABEL_TYPES)),
  itemCaption: PropTypes.string,
  itemActions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      hideOption: PropTypes.bool,
    }),
  ),
  isItemClickable: PropTypes.bool,
  onItemClick: PropTypes.func,
  withTopStatus: PropTypes.bool,
  nameLength: PropTypes.number,
};
export default ListItem;
